// interface AppContainerProps {
//   children: React.ReactNode;
// }

const AppContainer = ({ children }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--side-bg-color)]">
      <div className="flex min-h-screen w-screen max-w-app flex-col items-center justify-center bg-background text-fontBackground">
        {children}
      </div>
    </div>
  );
};

export default AppContainer;
